import { APPLICATION_RELATIONSHIP } from "@lending/types";
import { useProductType } from "../useProductType";
import { useGetAutoLoanApplicationQuery } from "./AutoLoanApplication/useGetAutoLoanApplicationQuery";
import { useGetCreditCardApplicationQuery } from "./CreditCardApplication/useGetCreditCardApplicationQuery";
import { useGetPersonalLoanApplicationQuery } from "./PersonalLoanApplication/useGetPersonalLoanApplicationQuery";

function useGetCoApplicantQuery() {
  const productType = useProductType();

  const isAutoLoan = productType === "auto-loan";
  const isCreditCard = productType === "credit-card";
  const isPersonalLoan = productType === "personal-loan" || productType === null;

  const personalLoanQuery = useGetPersonalLoanApplicationQuery({
    enabled: isPersonalLoan,
  });
  const autoLoanQuery = useGetAutoLoanApplicationQuery({
    enabled: isAutoLoan,
  });
  const creditCardQuery = useGetCreditCardApplicationQuery({
    enabled: isCreditCard,
  });

  const application = isAutoLoan
    ? autoLoanQuery.data
    : isCreditCard
      ? creditCardQuery.data
      : personalLoanQuery.data;

  const isLoading = isAutoLoan
    ? autoLoanQuery.isLoading
    : isCreditCard
      ? creditCardQuery.isLoading
      : personalLoanQuery.isLoading;

  const isError = isAutoLoan
    ? autoLoanQuery.isError
    : isCreditCard
      ? creditCardQuery.isError
      : personalLoanQuery.isError;

  const refetch = isAutoLoan
    ? autoLoanQuery.refetch
    : isCreditCard
      ? creditCardQuery.refetch
      : personalLoanQuery.refetch;

  const additionalApplicants = application?.additional_applicants;
  const coApplicant = additionalApplicants?.find(
    (applicant) => applicant.application_relationship === APPLICATION_RELATIONSHIP.CO_APPLICANT
  );

  return { coApplicant, application, isLoading, isError, refetch };
}

export { useGetCoApplicantQuery };
